import IconButton from 'components/common/IconButton';
import SoftBadge from 'components/common/SoftBadge';
import { useToast } from 'context/providers/ToastProvider';
import useFiltro from 'hooks/useFiltro';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Form, OverlayTrigger, Row, Spinner, Table, Tooltip } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';

const LogServicios = () => {

    const [vendedores, setVendedores] = useState([]);
    const [tipoLicencias, setTipoLicencias] = useState([]);
    const [logServicios, setLogServicios] = useState([]);
    const [cargando, setCargando] = useState(true);
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const { FiltroLog, setFiltroLog, resetFiltroLog } = useFiltro();

    // Estados para paginación
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize] = useState(20); // Número de elementos por página
    const [hasMoreData, setHasMoreData] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const mostrarLogs = async (page = 1, append = false) => {
        if (!append) {
            setCargando(true);
        } else {
            setLoadingMore(true);
        }

        // Preparar objeto con filtros y paginación
        const filtrosConPaginacion = {
            ...FiltroLog,
            pageNumber: page,
            pageSize: pageSize
        };

        const response = await fetch("/api/logservicios/ObtenerCatalogoLogs?vFiltro=" + encodeURIComponent(JSON.stringify(filtrosConPaginacion)),
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            const nuevosLogs = data["table1"] || [];

            if (append) {
                setLogServicios(prev => [...prev, ...nuevosLogs]);
            } else {
                setLogServicios(nuevosLogs);
                setPageNumber(1);
            }

            // Verificar si hay más datos disponibles
            const totalRecordsFromResponse = data["table2"]?.[0]?.totalRecords || 0;
            setTotalRecords(totalRecordsFromResponse);
            setHasMoreData((page * pageSize) < totalRecordsFromResponse);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
            if (!append) {
                setLogServicios([]);
                setHasMoreData(false);
            }
        }

        if (!append) {
            setCargando(false);
        } else {
            setLoadingMore(false);
        }
    };

    /**
     * Función para cargar más datos (infinite scroll)
     */
    const cargarMasDatos = () => {
        if (hasMoreData && !loadingMore && !cargando) {
            const nextPage = pageNumber + 1;
            setPageNumber(nextPage);
            mostrarLogs(nextPage, true);
        }
    };

    /**
     * Componente para el trigger de infinite scroll
     */
    const InfiniteScrollTrigger = () => {
        const triggerRef = React.useRef();

        React.useEffect(() => {
            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && hasMoreData && !loadingMore && !cargando) {
                        cargarMasDatos();
                    }
                },
                { threshold: 0.1 }
            );

            if (triggerRef.current) {
                observer.observe(triggerRef.current);
            }

            return () => {
                if (triggerRef.current) {
                    observer.unobserve(triggerRef.current);
                }
            };
        }, [hasMoreData, loadingMore, cargando, pageNumber]);

        if (!hasMoreData) return null;

        return (
            <div ref={triggerRef} className="text-center py-4">
                {loadingMore ? (
                    <div>
                        <Spinner animation="border" variant="primary" className="mb-2" />
                        <div className="text-muted small">Cargando más logs...</div>
                    </div>
                ) : (
                    <div className="text-muted small">Desplázate para cargar más</div>
                )}
            </div>
        );
    };

    const obtenerDatosBusqueda = async () => {
        setCargando(true);
        const response = await fetch("/api/logservicios/ObtenerDatosBusqueda",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();

            setVendedores(data['table1']);
            setTipoLicencias(data['table2']);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargando(false);
        mostrarLogs()
    };

    /**
     * Resetear filtros y recargar
     */
    const handleResetFiltros = () => {
        resetFiltroLog();
        setPageNumber(1);
        setHasMoreData(true);
        setLogServicios([]);
        mostrarLogs(1, false);
    };

    /**
     * Buscar con filtros y resetear paginación
     */
    const handleBuscar = () => {
        setPageNumber(1);
        setHasMoreData(true);
        setLogServicios([]);
        mostrarLogs(1, false);
    };

    useEffect(() => {
        obtenerDatosBusqueda();
    }, []);

    return (
        <>
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center">
                    <Col xs="auto">
                        <img src="/img/historial48.png" alt="connectCircle" height={30} />
                    </Col>
                    <Col>
                        <h5>
                            Logs de Servicios de Akasia
                        </h5>
                    </Col>
                </Row>
            </Card>

            <Card className="mb-3">
                <Card.Header>
                    <Row className="flex-between-center mb-2">
                        <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                            <Form.Select
                                size="sm"
                                aria-label="Default select"
                                value={FiltroLog.vNombreVendedor}
                                onChange={(event) => { setFiltroLog({ ...FiltroLog, vNombreVendedor: event.target.value }) }}
                            >
                                <option value="">Todos los vendedores</option>
                                <option value="NoAsignados">No asignados</option>
                                {vendedores.map((vendedor, index) => {
                                    return (<option key={index} value={vendedor.vUsuario}>{vendedor.vNombre} {vendedor.vApellidos}</option>)
                                })}
                            </Form.Select>
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                            <Form.Select
                                size="sm"
                                aria-label="Default select"
                                value={FiltroLog.vTipoLicencia}
                                onChange={(event) => { setFiltroLog({ ...FiltroLog, vTipoLicencia: event.target.value }) }}
                            >
                                <option value="">Todos las licencias</option>
                                {tipoLicencias.map((licencia, index) => {
                                    return (<option key={index} value={licencia.idCatTipoLicencia}>{licencia.vDescripcionTipo}</option>)
                                })}
                            </Form.Select>
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                            <Form.Select
                                size="sm"
                                value={FiltroLog.vEstatusLicencia}
                                onChange={(event) => { setFiltroLog({ ...FiltroLog, vEstatusLicencia: event.target.value }) }}
                                aria-label="Default select"
                            >
                                <option value="">Todos los estatus</option>
                                <option value="prueba">Prueba</option>
                                <option value="activa">Activa</option>
                                <option value="cancelada">Canceladas</option>
                            </Form.Select>
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                            <Form.Control
                                size="sm"
                                value={FiltroLog.vNombreEmpresa}
                                aria-label="Default select"
                                placeholder="Nombre Empresa o Cliente"
                                onChange={(event) => { setFiltroLog({ ...FiltroLog, vNombreEmpresa: event.target.value.toUpperCase() }) }}
                            />
                        </Col>
                    </Row>

                    <Row className="flex-between-center">
                        <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                            <Form.Control
                                size="sm"
                                aria-label="Default select"
                                placeholder="Movimiento"
                                value={FiltroLog.vMovimiento}
                                onChange={(event) => { setFiltroLog({ ...FiltroLog, vMovimiento: event.target.value.toUpperCase() }) }}
                            />
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={3} className="d-flex align-items-center pe-0 mb-2">
                            {cargando ? (
                                <Button variant="falcon-default" size="sm" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    &nbsp;Buscando...
                                </Button>
                            ) : (
                                <>
                                    <IconButton
                                        variant="falcon-default"
                                        size="sm"
                                        icon="search"
                                        transform="shrink-3"
                                        onClick={handleBuscar}
                                    >
                                        <span className="d-none d-sm-inline-block ms-1">Buscar</span>
                                    </IconButton>
                                    <IconButton
                                        variant="falcon-default"
                                        size="sm"
                                        icon="redo-alt"
                                        transform="shrink-3"
                                        className="mx-2"
                                        onClick={handleResetFiltros}
                                    >
                                        <span className="d-none d-sm-inline-block ms-1">Reset</span>
                                    </IconButton>
                                </>
                            )}
                        </Col>
                    </Row>
                </Card.Header>

                <Card.Body className="p-0">
                    {cargando ? (
                        <div className="p-4">
                            {[...Array(5)].map((_, index) => (
                                <Card key={index} className="mb-2">
                                    <Card.Body className="p-2">
                                        <Row>
                                            <Col xs={2}><Skeleton height={20} /></Col>
                                            <Col xs={2}><Skeleton height={20} /></Col>
                                            <Col xs={2}><Skeleton height={20} /></Col>
                                            <Col xs={3}><Skeleton height={20} /></Col>
                                            <Col xs={3}><Skeleton height={20} /></Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    ) : logServicios.length > 0 ? (
                        <div className="p-3">
                            <div className="mb-3 d-flex justify-content-between align-items-center">
                                <small className="text-muted">
                                    Mostrando {logServicios.length} de {totalRecords > 0 ? totalRecords : logServicios.length} logs
                                </small>
                            </div>

                            <div className="table-responsive">
                                <Table striped hover size="sm" className="fs--2 mb-0">
                                    <thead className="bg-200 text-900">
                                        <tr>
                                            <th></th>
                                            <th>Fecha</th>
                                            <th>ID Lic</th>
                                            <th>Vendedor</th>
                                            <th>Estatus</th>
                                            <th>Versión</th>
                                            <th>IP</th>
                                            <th>Empresa</th>
                                            <th>Movimiento</th>
                                            <th>Cliente</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {logServicios.map((log, index) => (
                                            <tr key={index} className="align-middle">
                                                <td>
                                                    <Link to={"/licencias/detalle/" + log.idLicencia}>
                                                        <img title="Ver información" src="../img/ver20.png" alt="Ver" />
                                                    </Link>
                                                </td>
                                                <td>{log.dCreatedDate}</td>
                                                <td>
                                                    <OverlayTrigger
                                                        placement="right"
                                                        overlay={
                                                            <Tooltip>
                                                                <strong>UUID EMPRESA</strong>
                                                                <p>{log.vUUIDEmpresa}</p>
                                                                <strong>UUID LICENCIA</strong>
                                                                <p>{log.vUUIDLicencia}</p>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Link to={"/licencias/detalle/" + log.idLicencia}>
                                                            <span className={log.bIsPeriodoPrueba ? "text-danger fw-bold" : "fw-bold"}>
                                                                {log.idLicencia}
                                                            </span>
                                                        </Link>
                                                    </OverlayTrigger>
                                                </td>
                                                <td className={log.bIsPeriodoPrueba ? "text-danger" : ""}>
                                                    <span className="text-truncate d-inline-block" style={{ maxWidth: '150px' }}>
                                                        {log.vNombreVendedor}
                                                    </span>
                                                </td>
                                                <td>
                                                    {log.bCancelado ? (
                                                        <SoftBadge pill bg='danger'>CANCELADO</SoftBadge>
                                                    ) : (
                                                        <>
                                                            {log.bIsPeriodoPrueba ?
                                                                <img src="../img/noactivo.png" alt="Inactivo" /> :
                                                                <img src="../img/activo.png" alt="Activo" />
                                                            }
                                                            {log.idCatTipoLicencia == 3 && (
                                                                <OverlayTrigger
                                                                    overlay={
                                                                        <Tooltip>
                                                                            <strong>NUBE AKASIA</strong><br />
                                                                            <span>Vencimiento: {log.dFinLicenciaUso}</span><br />
                                                                            <span>Restante: {log.dDiasFaltantes} días</span>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    {log.dDiasFaltantes > 0 ?
                                                                        <img src="../img/nubeActiva.png" alt="Nube Activa" /> :
                                                                        <img src="../img/nubeVencida.png" alt="Nube Vencida" />
                                                                    }
                                                                </OverlayTrigger>
                                                            )}
                                                            {log.iEstadoPoliza == 1 && (
                                                                <OverlayTrigger
                                                                    overlay={
                                                                        <Tooltip>
                                                                            <strong>PÓLIZA SOPORTE TÉCNICO</strong><br />
                                                                            <span>Vencimiento: {log.dFechaVencimientoSoporte}</span>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <img src="../img/polizaActiva.png" alt="Póliza Activa" />
                                                                </OverlayTrigger>
                                                            )}
                                                            {log.iEstadoPoliza == 2 && (
                                                                <OverlayTrigger
                                                                    overlay={
                                                                        <Tooltip>
                                                                            <strong>PÓLIZA SOPORTE TÉCNICO</strong><br />
                                                                            <span>Vencimiento: {log.dFechaVencimientoSoporte}</span>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <img src="../img/polizaVencida.png" alt="Póliza Vencida" />
                                                                </OverlayTrigger>
                                                            )}
                                                            {log.iEstadoPoliza == 3 && (
                                                                <OverlayTrigger
                                                                    overlay={
                                                                        <Tooltip>
                                                                            <strong>PÓLIZA SOPORTE TÉCNICO</strong><br />
                                                                            <span>Vencimiento: {log.dFechaVencimientoSoporte}</span>
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <img src="../img/polizaPorVencer.png" alt="Póliza Por Vencer" />
                                                                </OverlayTrigger>
                                                            )}
                                                        </>
                                                    )}
                                                </td>
                                                <td className={log.bIsPeriodoPrueba ? "text-danger" : ""}>
                                                    {log.vVersion}
                                                </td>
                                                <td>
                                                    {log.vNombreSucursal && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip><strong>{log.vNombreSucursal}</strong></Tooltip>}
                                                        >
                                                            <img src="/img/sucursal20.png" alt="Sucursal" className="me-1" />
                                                        </OverlayTrigger>
                                                    )}
                                                    {log.vDatosHardware && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip><strong>{log.vDatosHardware}</strong></Tooltip>}
                                                        >
                                                            <img src="/img/pcautorizada20.png" alt="PC" className="me-1" />
                                                        </OverlayTrigger>
                                                    )}
                                                    {log.vLatLonSistema && (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip><strong>{log.vLatLonSistema}</strong></Tooltip>}
                                                        >
                                                            <a href={"https://www.google.com/maps/place/" + log.vLatLonSistema} target="_blank" rel="noreferrer">
                                                                <img src="/img/ubicacion20.png" alt="Ubicación" />
                                                            </a>
                                                        </OverlayTrigger>
                                                    )}
                                                </td>
                                                <td className={log.bIsPeriodoPrueba ? "text-danger" : ""}>
                                                    <Link to={"/licencias/detalle/" + log.idLicencia}>
                                                        <span className="text-truncate d-inline-block" style={{ maxWidth: '200px' }}>
                                                            {log.vNombreEmpresa}
                                                        </span>
                                                    </Link>
                                                </td>
                                                <td className={log.bIsPeriodoPrueba ? "text-danger" : ""}>
                                                    <span className="text-truncate d-inline-block" style={{ maxWidth: '300px' }}>
                                                        {log.vMovimiento}
                                                    </span>
                                                </td>
                                                <td>
                                                    <OverlayTrigger
                                                        placement="left"
                                                        overlay={
                                                            <Tooltip className="fs--2">
                                                                {log.vTelefonoPersonal && (
                                                                    <><strong>TEL. PERSONAL</strong><br />{log.vTelefonoPersonal}<br /></>
                                                                )}
                                                                {log.vTelefonoTrabajo && (
                                                                    <><strong>TEL. TRABAJO</strong><br />{log.vTelefonoTrabajo}<br /></>
                                                                )}
                                                                {log.vEmail && (
                                                                    <><strong>E-MAIL</strong><br />{log.vEmail}</>
                                                                )}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <Link to={"/clientes/detalle/" + log.idClienteAkasia}>
                                                            <span className={`text-truncate d-inline-block ${log.bIsPeriodoPrueba ? "text-danger" : ""}`} style={{ maxWidth: '200px' }}>
                                                                {log.vNombreCliente}
                                                            </span>
                                                        </Link>
                                                    </OverlayTrigger>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>

                            <InfiniteScrollTrigger />
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <div className="mb-3">
                                <img src="/img/historial48.png" alt="No hay logs" height={60} className="opacity-50" />
                            </div>
                            <h5 className="text-muted">No se encontraron logs</h5>
                            <p className="text-muted">
                                No hay registros con los filtros seleccionados
                            </p>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </>
    );
};

export default LogServicios;
